<template>
  <ion-toolbar>
    <ion-title>
      <span v-if="job.convertedDate">{{ job.convertedDateYear }}</span>
      <span v-else>Guest Shift</span>
    </ion-title>
  </ion-toolbar>


  <div class="main_wrapper ion-padding">
    <div class="container">
      <div class="job_info_wrapper job_info_wrapper--custom">
        <div class="image_text_comp image_text_comp--mb" v-if="job.pharmacy">
          <div class="image_wrapper">
            <el-avatar :size="'small'" shape="square" :src="job.pharmacyImage" v-if="job.pharmacyImage" />
            <el-avatar :size="'small'" shape="square" icon="el-icon-user-solid" v-else></el-avatar>
          </div>
          <div class="text_wrapper">
            <div class="main_text">{{ job.pharmacy.name }}</div>
            <div class="additional_text">
              <span>{{ $filters.addressText(job.pharmacy.address) }}</span>
            </div>
          </div>
        </div>
        <div class="rate_shifts_info">
          <div class="info_wrapper">
            <div class="info_title">Available shifts</div>
            <div class="info_value">
              <span>{{ job.convertedDate }}</span>
            </div>
          </div>
        </div>
        <el-table :data="job.shiftDatas" style="width: 100%">
          <el-table-column prop="date" label="Date" width="110" />
          <el-table-column prop="startTime" label="Start time" width="110" />
          <el-table-column prop="endTime" label="End Time" width="110" />
          <el-table-column :label="isAustralia ? 'Rate (excluding super)' : 'Rate'" width="190">
            <template #default="scope">
              <span>{{ Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(scope.row.rate) }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="info-outer">
          <div class="info_wrapper" v-if="job.notes">
            <div class="info_title">Shift Notes</div>
            <div class="info_value">
              <span style="white-space: pre-line">{{ job.notes }}</span>
            </div>
          </div>
          <div v-else></div>
        </div>
        <el-form class="job_shifts_wrapper fullp" :model="formsData.userForm" :rules="formsData.userForm.rules"
          :ref="(el) => (formsData.userForm.ref = el)" :label-position="'top'" @submit.prevent="submit('userForm')">
          <el-form-item :required="false">
            <el-checkbox v-model="formsData.userForm.acceptLocumateTc.value" @change="onChangeTech"> I Accept the {{$filters.appName() }}
            </el-checkbox>
            <span class="tc-link ml-1"><router-link
                :to="{ name: 'terms_and_conditions_guest_shift' }">T&C's</router-link></span>
          </el-form-item>
          <el-form-item :required="false">
            <el-checkbox v-model="formsData.userForm.acceptPharmacyTc.value" @change="onChangeTech"> I Accept the <span v-if="isAustralia">Pharmacy</span><span v-else>Employer</span>
            </el-checkbox>
            <span class="tc-link ml-1" @click="showPopup()">T&C's</span>
          </el-form-item>
          <div v-if="job.guest.aphra == 1">
            <el-form-item class="no-scroll" label="Expiration Date" prop="ahpraExpiryDate" :required="true">
              <el-date-picker popper-class="datepicker_popper drawer-style" v-model="formsData.userForm.ahpraExpiryDate.valueFormatted"
                type="date" :placeholder="isAustralia ? 'DD/MM/YYYY' : 'MM/DD/YYYY'" :format="$filters.systemDateFormat()" @change="dateConvert"
                @input="checkFormValidation('userForm', true)">
              </el-date-picker>
            </el-form-item>
            <div class="proof-ins">Insurance Document</div>
            <el-form-item v-if="insuranceDocument.length <= 1">
              <el-upload class="uploader-support" :action="'upload'"
                :ref="(el) => (formsData.userForm.insuranceDocument.ref = el)" name="insuranceDocument"
                list-type="picture" :thumbnail-mode="true" :on-preview="cropperOthersMethods.handlePreview" :limit="1"
                :on-exceed="cropperOthersMethods.handleExceed" :drag="true" :on-change="cropperOthersMethods.handleChange"
                :before-upload="cropperOthersMethods.beforeAvatarUpload">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  Drop file here or <em>click to upload</em>
                </div>
                <template #file="{ file }">
                  <div v-if="file.raw.type == 'application/pdf'" class="el-upload-list__item-body">
                                        <img class="el-upload-list__item-body-thumbnail"
                                            :src="require('@/assets/img/icons/pdf.svg')" />
                                        <span class="mx-2" size="large">{{ file.name }}</span>
                                    </div>
                                    <div class="el-upload-list__item-body" v-else>
                                        <img class="el-upload-list__item-body-thumbnail" :src="file.url" alt="" />
                                        <span class="mx-2" size="large">{{ file.name }}</span>
                                    </div>
                                    <div class="el-upload-list__item-actions">
                                        <button class="el-upload-list__item-actions-action"
                                            @click.prevent="cropperOthersMethods.handleRemove(file)">
                                            <img :src="require('@/assets/img/icons/trash.svg')" />
                                        </button>
                                    </div>
                 
                </template>
              </el-upload>
            </el-form-item>
          </div>
          <el-form-item>
            <div>
              <div class="demo-collapse ">
                <el-collapse accordion>
                  <el-collapse-item :title="`What is ${$filters.appName()}`" name="1">
                    <div class="search_jobs_header">
                      <img :src="require(`@/assets/img/illustrations/search1.svg`)" alt="" />
                      <div class="main_title">What is {{$filters.appName() }}</div>
                      <div class="mt-2 fz" v-if="isAustralia">
                        Australia’s Locum Marketplace. We help pharmacies engage with the largest network of trusted
                        independent
                        locums to cover illnesses, holidays and training… or just to help out when it’s super busy.
                      </div>
                      <div v-else>
                        We empower pharmacy professionals to take control of their careers, with the flexibility to choose when and where they work while for pharmacies we create capacity, alleviate staff shortages, and address burnout, ultimately enhancing patient care.
                      </div>
                      <el-button class="mt-3" :type="'blue'" @click="close()">
                        Sign up to {{$filters.appName() }}
                      </el-button>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>
            </div>
          </el-form-item>
          <el-form-item class="button_submit mb0">
            <el-button class="submit_page" type="red" @click="gotToReject(job.id)">
              Reject
            </el-button>
            <el-button v-if="job.guest.aphra == 1" class="submit_page" type="blue"
              :disabled="formsData.userForm.disabled || disabled" @click="gotToAccept(job.id, 'userForm')">
              Accept
            </el-button>
            <el-button v-else class="submit_page" type="blue" :disabled="disabled"
              @click="gotToAccept(job.id, 'userForm')">
              Accept
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>

  <el-dialog v-model="centerDialogVisible" title="Pharmacy T&C's" width="30%" center>

    <div v-if="job.guest.termsAndConditions">
      <p style="white-space: pre-line">{{ job.guest.termsAndConditions }}</p>
    </div>

    <div v-if="job.contractUrl">
      <div class="image_wrapper">
        <div class="download-img-wrap">
          <div class="download-img">
            <a :href="job.contractUrl" target="_blank" download>
              <!-- <span class="locumate_icons locumate_icon-picture"></span> -->
              <p class="download-btn">Download Contract <i class="el-icon-download"></i></p>
            </a>
          </div>

        </div>
      </div>
    </div>
  </el-dialog>

  <div class="el_dialog_wraper">
            <el-drawer :direction="'btt'" class="success-prompt" custom-class="success-prompt" :destroy-on-close="true" :append-to-body="true" v-model="showJobApplicationPopupMessage" :title="drawerContent.status == 'accept' ? 'Shift Confirmed!' : 'Shift Rejected!'" width="30%"
                @closed="redirectClose">
                <div class="message text-center mt-3">
                    
                    <div class="col-right" v-if="drawerContent.status == 'accept'">
                        <svg width="150" height="150" viewBox="0 0 309 309" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="154.5" cy="154.5" r="153.25" stroke="#009F98" stroke-width="1.5"
                            stroke-dasharray="3 5" />
                        <circle cx="154.5" cy="154.5" r="137.5" fill="white" />
                        <path
                            d="M223.733 140.046L217.067 134.952C217.933 131.869 218.667 129.256 219.333 126.977C222 117.996 223.467 113.037 219.8 107.944C216.133 102.85 211.133 102.649 201.667 102.381H193.4C192.267 99.4321 191.4 96.8184 190.6 94.6067C187.533 85.7603 185.8 81.203 179.8 78.9243C173.8 76.6457 169.6 79.8626 161.867 85.2241L155.2 89.8484L148.533 85.3581C141.667 79.9296 136.6 76.5787 130.533 78.5892C124.467 80.5998 122.867 85.2911 119.733 94.2046C118.933 96.4163 118 99.03 116.933 102.046L108.333 102.314C99 102.314 93.8667 102.649 90.2 107.742C86.5333 112.836 88.3333 117.795 90.8667 126.843C91.5333 129.121 92.3333 131.735 93.1333 134.818L86.4667 139.912C79.2 145.541 75 148.691 75 155.058C75 161.425 79.0667 164.507 86.4667 170.204L93.1333 175.298C92.3333 178.38 91.5333 180.994 90.8667 183.273C88.2 192.253 86.7333 197.213 90.4 202.306C94.0667 207.4 99.2667 207.534 108.533 207.802H116.733C117.867 210.751 118.733 213.364 119.533 215.576C122.667 224.422 124.333 228.98 130.333 231.258C136.333 233.537 140.533 230.32 148.267 224.959L154.933 220.334L161.6 224.824C165.712 228.443 170.787 230.772 176.2 231.526C177.402 231.514 178.595 231.31 179.733 230.923C185.733 228.98 187.4 224.221 190.533 215.308C191.333 213.096 192.2 210.482 193.333 207.534H201.6C210.933 207.534 216.067 207.199 219.733 202.038C223.4 196.878 222 191.985 219.333 183.005C218.667 180.726 217.867 178.112 217.067 175.029L223.733 169.936C231.067 164.641 235 161.76 235 155.058C235 148.356 231.067 145.742 223.733 140.046Z"
                            fill="#009F98" />
                        <path
                            d="M144.133 190.309C143.232 190.271 142.348 190.05 141.534 189.658C140.721 189.266 139.994 188.713 139.4 188.031L119.733 165.981C118.557 164.648 117.957 162.9 118.063 161.122C118.169 159.343 118.974 157.68 120.3 156.498C121.626 155.316 123.365 154.712 125.134 154.819C126.903 154.926 128.557 155.735 129.733 157.068L144.533 173.89L186.733 132.606C187.341 131.914 188.085 131.356 188.917 130.967C189.749 130.578 190.653 130.366 191.571 130.344C192.488 130.322 193.401 130.491 194.251 130.84C195.101 131.189 195.87 131.711 196.509 132.372C197.149 133.034 197.646 133.822 197.969 134.686C198.292 135.55 198.434 136.471 198.387 137.393C198.339 138.315 198.102 139.216 197.691 140.042C197.281 140.867 196.705 141.599 196 142.19L148.8 188.567C147.526 189.732 145.854 190.356 144.133 190.309Z"
                            fill="white" />
                    </svg>
                    </div>
                    <div class="col-right" v-else>
                      <svg width="150" height="150" viewBox="0 0 309 309" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="154.5" cy="154.5" r="153.25" stroke="#009F98" stroke-width="1.5" stroke-dasharray="3 5"/>
                        <circle cx="154.5" cy="154.5" r="137.5" fill="white"/>
                        <path d="M223.733 140.046L217.067 134.952C217.933 131.869 218.667 129.256 219.333 126.977C222 117.996 223.467 113.037 219.8 107.944C216.133 102.85 211.133 102.649 201.667 102.381H193.4C192.267 99.4321 191.4 96.8184 190.6 94.6067C187.533 85.7603 185.8 81.203 179.8 78.9243C173.8 76.6457 169.6 79.8626 161.867 85.2241L155.2 89.8484L148.533 85.3581C141.667 79.9296 136.6 76.5787 130.533 78.5892C124.467 80.5998 122.867 85.2911 119.733 94.2046C118.933 96.4163 118 99.03 116.933 102.046L108.333 102.314C99 102.314 93.8667 102.649 90.2 107.742C86.5333 112.836 88.3333 117.795 90.8667 126.843C91.5333 129.121 92.3333 131.735 93.1333 134.818L86.4667 139.912C79.2 145.541 75 148.691 75 155.058C75 161.425 79.0667 164.507 86.4667 170.204L93.1333 175.297C92.3333 178.38 91.5333 180.994 90.8667 183.273C88.2 192.253 86.7333 197.213 90.4 202.306C94.0667 207.4 99.2667 207.534 108.533 207.802H116.733C117.867 210.751 118.733 213.364 119.533 215.576C122.667 224.422 124.333 228.98 130.333 231.258C136.333 233.537 140.533 230.32 148.267 224.959L154.933 220.334L161.6 224.824C165.712 228.443 170.787 230.772 176.2 231.526C177.402 231.514 178.595 231.31 179.733 230.923C185.733 228.98 187.4 224.221 190.533 215.308C191.333 213.096 192.2 210.482 193.333 207.534H201.6C210.933 207.534 216.067 207.198 219.733 202.038C223.4 196.878 222 191.985 219.333 183.005C218.667 180.726 217.867 178.112 217.067 175.029L223.733 169.936C231.067 164.641 235 161.76 235 155.058C235 148.356 231.067 145.742 223.733 140.046Z" fill="#E34457"/>
                        <path d="M180.358 180.34C182.547 178.152 182.547 174.531 180.358 172.343L163 154.991L180.358 137.638C182.547 135.45 182.547 131.829 180.358 129.641C178.17 127.453 174.547 127.453 172.358 129.641L155 146.993L137.642 129.641C135.453 127.453 131.83 127.453 129.642 129.641C127.453 131.829 127.453 135.45 129.642 137.638L147 154.991L129.642 172.343C127.453 174.531 127.453 178.152 129.642 180.34C130.774 181.472 132.208 182 133.642 182C135.075 182 136.509 181.472 137.642 180.34L155 162.988L172.358 180.34C173.491 181.472 174.925 182 176.358 182C177.792 182 179.226 181.472 180.358 180.34Z" fill="white"/>
                      </svg>


                    </div>
                    <div class="col-right">
                        <p class="header">{{ drawerContent.heading }}</p>

                    </div>
                    <div class="col-right">
                        <p>{{ drawerContent.statusMessage }}</p>

                    </div>
                </div>
                    <span v-if="drawerContent.status == 'accept'">
                        <el-button @click="redirectCloseNext" type="primary">Learn more about {{$filters.appName() }}</el-button>
                    </span>
                    <span class="dialog-footer w-100 close-inv">
                        <el-button @click="redirectClose" type="primary">Close</el-button>
                    </span>
            </el-drawer>
        </div>


</template>

<script>


import {
  ref,
  onMounted,
  inject
} from "vue";
import { ElMessage, ElMessageBox } from "@/components/Vendor/Element";
import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";
import formHooks from "@/hooks/form/form";
import FileHelpers from "@/helpers/file/file";
import formValidate from "@/hooks/form/validate/validate";

import { isAustraliaRegion } from '@/helpers/region/regionHelper.js';

import IMaskDirective from "@/directives/vue-imask/directive";

addIcons({
  "arrow-back-outline": arrowBackOutline,
});

import { useStore } from "vuex";
import {
  useRouter,
} from "vue-router";
export default {
  directives: {
    imask: IMaskDirective,
  },
  setup() {
    const $store = useStore();
    const $router = useRouter();

    const setPageClassGlobal = inject("setPageClassGlobal");
    const centerDialogVisible = ref(false);
    const disabled = ref(true);
    const fileHelpers = new FileHelpers();
    let job = ref($store.getters.getGuestShiftPublicDetails);
    const userData = $store.getters.GET_USER_DATA;
    let guest = ref(job.value.guest);
    let pharmacy = ref(job.value.pharmacy);
    const ahpra = userData.ahpra;
    const aphraRegistration = ref([]);
    const insuranceDocument = ref([]);
    const isAustralia = isAustraliaRegion();
    const showJobApplicationPopupMessage = ref(false);
    const drawerContent = ref({
      title: 'Invitation',
      heading: '',
      statusMessage: '',
      status:''
    });
    const $moment = inject(["$moment"]);
    const dateConvert = () => {
      if (formsData.userForm.ahpraExpiryDate.valueFormatted) {
        const result = $moment(
          formsData.userForm.ahpraExpiryDate.valueFormatted,
          "YYYY-MM-DD"
        ).format("YYYY-MM-DD");
        formsData.userForm.ahpraExpiryDate.value = result;
        checkFormValidation("userForm", true);
      } else {
        formsData.userForm.ahpraExpiryDate.value = null;
        checkFormValidation("userForm", true);
        return null;
      }
    };
    const ahpraExpiryDateValue = ahpra
      ? $moment(ahpra, ["YYYY-MM-DD"])
      : new Date(new Date().setFullYear(new Date().getFullYear()));
    const formsDataArray = {
      userForm: {
        acceptLocumateTc: {
          value: false,
        },
        acceptPharmacyTc: {
          value: false,
        },
        ahpraExpiryDate: {
          ref: null,
          value: ahpra.date ? ahpraExpiryDateValue : "",
          valueFormatted: ahpraExpiryDateValue,
          resetValue: true,
          ...(job.value.guest.aphra === 1
            ? {
              validators: [
                {
                  validator: (rule, formField, callback) => {
                    formValidate.validate(
                      rule,
                      formField,
                      {
                        rule: "nabpGuestExpiryDate",
                      },
                      callback,
                      setFormValidation
                    );
                  },
                },
              ],
            }
            : {}), // Add validators only if job.value.guest.aphra is 1
        },
        insuranceDocument: {
          ref: null,
          value: [],
          limit: 10,
          disabled: false,
          errors: null,
        },
      },
    };

    const onChangeTech = () => {

      if (job.value.guest.aphra == 1) {

        if (formsData.userForm.acceptLocumateTc.value == true && formsData.userForm.acceptPharmacyTc.value == true && formsData.userForm.insuranceDocument.value.length == 1 && formsData.userForm.disabled == false) {
          disabled.value = false;
        } else {
          disabled.value = true;
        }
      } else {
        if (formsData.userForm.acceptLocumateTc.value == true && formsData.userForm.acceptPharmacyTc.value == true) {
          disabled.value = false;
        } else {
          disabled.value = true;
        }
      }

    };

    const redirectClose = () =>{
      showJobApplicationPopupMessage.value = false;
        $router.push({
          name: "auth",
        });
    }

    const redirectCloseNext = () =>{
      showJobApplicationPopupMessage.value = false;
      if(isAustralia.value){

        window.location.href = 'https://locumate.com.au/get-locumate/';
      }else{
        window.location.href = 'https://healthshifts.ai/';

      }
    }

    const cropperOthersMethods = {
      beforeAvatarUpload(file) {
        const img = URL.createObjectURL(file.raw);
        console.log("🚀 ~ beforeAvatarUpload ~ img:", img)
      },
      handleRemove(file) {
        formsData.userForm.insuranceDocument.splice(
          formsData.userForm.insuranceDocument.indexOf(file),
          1
        );
        onChangeTech();
      },
      handleChange(file, files) {
        const type = fileHelpers.getFileType(file);

        if (type == "image" || type == "pdf") {
          formsData.userForm.insuranceDocument = files;
          formsData.userForm.insuranceDocument.value = files;
        } else {
          files.pop();
          formsData.userForm.insuranceDocument.value = null;
          ElMessage({
            type: "error",
            message: `Document must be JPG JPEG PNG JFIF or PDF format!`,
          });
        }
        onChangeTech();
      },

      handlePreview(/*file*/) { },
      handleExceed(file, files) {
        ElMessage({
          type: "error",
          message: `You can upload 1 insurance documents, you selected ${files.length} `,
        });
      },
    };

    const close = () => {
      $router.push({
        name: "auth",
      });
    }

    const showPopup = () => {
      centerDialogVisible.value = true;

    }

    const gotToReject = (id) => {
      (async () => {
        try {
          const form = new FormData();
          form.append(`id`, id);
          await $store.dispatch("GUEST_SHIFT_REJECT", form);
          // let massageText = {
          //   title: 'Shift Rejected!',
          //   main: 'You have rejected the shift. Respective pharmacy will be notified. Thank You !'
          // };
          ElMessage.success("Shift Rejected Successfully!!");
          drawerContent.value = {
                    title: 'Shift Rejected!',
                    heading: 'Shift Rejected!',
                    statusMessage: 'You have rejected the shift. Respective pharmacy will be notified. Thank You !',
                    status:'decline'
                  };
          showJobApplicationPopupMessage.value = true;

          // await ElMessageBox.confirm(massageText.main, massageText.title, {
          //   showCancelButton: false,
          //   confirmButtonText: 'Sign up to Locumate',
          //   confirmButtonClass: 'el-button--grey',
          //   showClose: true,
          //   type: 'warning',
          //   customClass: 'modal_success star',
          //   callback: () => {
          //     $router.push({
          //       name: "auth",
          //     });
          //   }
          // });

        } catch (error) {
          console.log(error);
          console.log("error submit!!");
        }
      })();
    }

    const gotToAccept = (id, formName) => {
      (async () => {
        try {
          await ElMessageBox.confirm(
            `Are you sure you want to confirm the booking?`,
            "Booking",
            {
              confirmButtonText: "Confirm",
              cancelButtonText: "Cancel",
              confirmButtonClass: "el-button--blue",
              cancelButtonClass: "el-button--grey",
              showClose: false,
            }
          );
          const form = new FormData();
          if (job.value.guest.aphra == 1) {
            formsRefs[formName].value.validate((valid) => {
              if (valid) {
                let otherFormData = getFormValues(formName);
                console.log("🚀 ~ formsRefs[formName].value.validate ~ otherFormData:", otherFormData)
                for (const key in otherFormData) {
                  if (key !== 'insuranceDocument') {
                    if (key === 'ahpraExpiryDate' && otherFormData[key]) {
                      const formattedDate = otherFormData[key];
                      form.append(key, formattedDate);
                    } else {
                      form.append(key, otherFormData[key]);
                    }
                  }
                }
                const canvasInsuranceDoc = formsData.userForm.insuranceDocument.value;
                let counterOther = 0;
                if (canvasInsuranceDoc.length != 0) {

                  canvasInsuranceDoc.map((item) => {
                    form.append(`file[insuranceFile][${counterOther}]`, item.raw);
                    counterOther++;
                  });
                } else {
                  ElMessage({
                    showClose: "true",
                    type: "warning",
                    message: " Please upload the Insurance document",
                  });
                  console.log("error submit!!");
                  return false;
                }
              }
            });
          }

          form.append(`id`, id);

          (async () => {
            try {
              await $store.dispatch("GUEST_SHIFT_ACCEPT", form);
              // let massageText = {
              //   title: 'Shift Confirmed!',
              //   main: 'Your shift has been recorded and a shift agreement has been recorded on your behalf with the pharmacy'
              // };
              ElMessage.success("Shift Confirmed Successfully!!");
            drawerContent.value = {
                      title: 'Shift Confirmed!',
                      heading: 'Shift Confirmed!',
                      statusMessage: 'Your shift has been recorded and a shift agreement has been recorded on your behalf with the pharmacy',
                      status:'accept'
                    };
            showJobApplicationPopupMessage.value = true;

      //         await ElMessageBox.confirm(massageText.main, massageText.title, {
      //           showCancelButton: true,
      //           confirmButtonText: 'Learn more about Locumate',
      //           cancelButtonText: 'Close',
      //           confirmButtonClass: 'el-button--blue',
      //           cancelButtonClass: "el-button--grey",
      //           showClose: false,
      //           type: 'success',
      //           customClass: 'modal_success star guest',
      //         }).then((action) => {
      //           console.log("🚀 ~ action:", action)
      //           if (action === 'confirm') {
      //             window.location.href = 'https://locumate.com.au/get-locumate/';
      //           } else {
      //             try {
      //               $router.push({
      //                 name: 'auth',
      //               });
      //           } catch (error) {
      //             console.error('Error navigating to auth route:', error);
      //           }

      //           }
      //         }).catch((error) => {
      //           console.log(error);
      //           $router.push({
      //   name: 'auth',
      // });
      //         });

            } catch (error) {
              console.log(error);
              console.log("error submit!!");
            }
          })();
        } catch (error) {
          console.log(error);
        }
      })();
    }




    onMounted(() => {
      setPageClassGlobal("global_job_book_page");
      setFormRefs();

      checkFormValidation("userForm", false);
    });

    const {
      ["onFormMaskAccept"]: onFormMaskAccept,
      checkFormValidation,
      setFormValidation,
      setFormRefs,
      formsData,
      getFormValues,
      formsRefs,
    } = formHooks(formsDataArray);
    return {
      formsData,
      job,
      guest,
      disabled,
      onChangeTech,
      gotToAccept,
      gotToReject,
      pharmacy,
      centerDialogVisible,
      showPopup,
      cropperOthersMethods,
      aphraRegistration,
      insuranceDocument,
      close,
      dateConvert,
      onFormMaskAccept,
      isAustralia,
      showJobApplicationPopupMessage,
      redirectClose,
      drawerContent,
      redirectCloseNext
    };
  },
};
</script>
